import { connect } from 'react-redux';
import DrawerNavComponent from '../components/drawer_nav';
import ConversationCreatorActions from '../actions/conversation_creator';
import SearchActions from '../actions/search';

const DrawerNavContainer = connect(
  null,
  {
    openConversationCreator: ConversationCreatorActions.open,
    setSearchResults: SearchActions.setSearchResults
  }
)(DrawerNavComponent);

export default DrawerNavContainer;
